import { Barbershop, QueueState } from "../../types";

/**
 * The queue opens up to 30 minutes before the store opens.
 * Only show pre-open messaging within this window.
 */
const PRE_OPEN_WINDOW_MINUTES = 30;

/**
 * Determines if a barbershop is in "pre-open" state:
 * the queue is open but the store hasn't physically opened yet,
 * AND the store opens within the next 30 minutes.
 */
export function isPreOpen(barbershop: Barbershop | null | undefined): boolean {
  if (!barbershop) return false;

  const { queueState, openTime } = barbershop;

  // Queue must be open for pre-open state
  if (queueState !== QueueState.open) return false;

  // We need a scheduled opening time to determine pre-open
  if (!openTime || typeof openTime !== "string") return false;

  const parts = openTime.split(":");
  if (parts.length < 2) return false;

  const hours = parseInt(parts[0], 10);
  const minutes = parseInt(parts[1], 10);
  if (isNaN(hours) || isNaN(minutes)) return false;

  const now = new Date();
  const openDate = new Date();
  openDate.setHours(hours, minutes, 0, 0);

  // Not yet open AND opens within the next 30 minutes
  const msUntilOpen = openDate.getTime() - now.getTime();
  return msUntilOpen > 0 && msUntilOpen <= PRE_OPEN_WINDOW_MINUTES * 60 * 1000;
}
